
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeTugFilled as ObiVesselTypeTugFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-tug-filled.js';
 
 
 

 
 export const ObiVesselTypeTugFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-tug-filled',
   elementClass: ObiVesselTypeTugFilledElement,
   events: {
     
   }
  });
 
 